export const SET_DEMANDES_RECRUTEMENT_LOADING = "SET_DEMANDES_RECRUTEMENT_LOADING";
export const SET_DEMANDES_RECRUTEMENT_ERROR = "SET_DEMANDES_RECRUTEMENT_ERROR";

export const FETCH_DEMANDES_RECRUTEMENT_REQUEST = "FETCH_DEMANDES_RECRUTEMENT_REQUEST";
export const FETCH_DEMANDES_RECRUTEMENT_SUCCESS = "FETCH_DEMANDES_RECRUTEMENT_SUCCESS";
export const FETCH_DEMANDES_RECRUTEMENT_FAIL = "FETCH_DEMANDES_RECRUTEMENT_FAIL";

export const CREATE_DEMANDE_RECRUTEMENT_REQUEST = "CREATE_DEMANDE_RECRUTEMENT_REQUEST";
export const CREATE_DEMANDE_RECRUTEMENT_SUCCESS = "CREATE_DEMANDE_RECRUTEMENT_SUCCESS";
export const CREATE_DEMANDE_RECRUTEMENT_FAIL = "CREATE_DEMANDE_RECRUTEMENT_FAIL";

export const UPDATE_DEMANDE_RECRUTEMENT_REQUEST = "UPDATE_DEMANDE_RECRUTEMENT_REQUEST";
export const UPDATE_DEMANDE_RECRUTEMENT_SUCCESS = "UPDATE_DEMANDE_RECRUTEMENT_SUCCESS";
export const UPDATE_DEMANDE_RECRUTEMENT_FAIL = "UPDATE_DEMANDE_RECRUTEMENT_FAIL";

export const DELETE_DEMANDE_RECRUTEMENT_REQUEST = "DELETE_DEMANDE_RECRUTEMENT_REQUEST";
export const DELETE_DEMANDE_RECRUTEMENT_SUCCESS = "DELETE_DEMANDE_RECRUTEMENT_SUCCESS";
export const DELETE_DEMANDE_RECRUTEMENT_FAIL = "DELETE_DEMANDE_RECRUTEMENT_FAIL";

export const APPROVE_DEMANDE_RECRUTEMENT_REQUEST = "APPROVE_DEMANDE_RECRUTEMENT_REQUEST";
export const APPROVE_DEMANDE_RECRUTEMENT_SUCCESS = "APPROVE_DEMANDE_RECRUTEMENT_SUCCESS";
export const APPROVE_DEMANDE_RECRUTEMENT_FAIL = "APPROVE_DEMANDE_RECRUTEMENT_FAIL";

export const REJECT_DEMANDE_RECRUTEMENT_REQUEST = "REJECT_DEMANDE_RECRUTEMENT_REQUEST";
export const REJECT_DEMANDE_RECRUTEMENT_SUCCESS = "REJECT_DEMANDE_RECRUTEMENT_SUCCESS";
export const REJECT_DEMANDE_RECRUTEMENT_FAIL = "REJECT_DEMANDE_RECRUTEMENT_FAIL";

export const CANCEL_DEMANDE_RECRUTEMENT_REQUEST = "CANCEL_DEMANDE_RECRUTEMENT_REQUEST";
export const CANCEL_DEMANDE_RECRUTEMENT_SUCCESS = "CANCEL_DEMANDE_RECRUTEMENT_SUCCESS";
export const CANCEL_DEMANDE_RECRUTEMENT_FAIL = "CANCEL_DEMANDE_RECRUTEMENT_FAIL";

export const SAVE_DEMANDE_RECRUTEMENT_CIBLAGE_REQUEST = "SAVE_DEMANDE_RECRUTEMENT_CIBLAGE_REQUEST";
export const SAVE_DEMANDE_RECRUTEMENT_CIBLAGE_SUCCESS = "SAVE_DEMANDE_RECRUTEMENT_CIBLAGE_SUCCESS";
export const SAVE_DEMANDE_RECRUTEMENT_CIBLAGE_FAIL = "SAVE_DEMANDE_RECRUTEMENT_CIBLAGE_FAIL";

export const SEND_DEMANDE_RECRUTEMENT_CIBLAGE_REQUEST = "SEND_DEMANDE_RECRUTEMENT_CIBLAGE_REQUEST";
export const SEND_DEMANDE_RECRUTEMENT_CIBLAGE_SUCCESS = "SEND_DEMANDE_RECRUTEMENT_CIBLAGE_SUCCESS";
export const SEND_DEMANDE_RECRUTEMENT_CIBLAGE_FAIL = "SEND_DEMANDE_RECRUTEMENT_CIBLAGE_FAIL";



export const SEND_OFFER_TO_CHASSEURS_REQUEST = 'SEND_OFFER_TO_CHASSEURS_REQUEST';
export const SEND_OFFER_TO_CHASSEURS_SUCCESS = 'SEND_OFFER_TO_CHASSEURS_SUCCESS';
export const SEND_OFFER_TO_CHASSEURS_FAIL = 'SEND_OFFER_TO_CHASSEURS_FAIL';

export const SEND_OFFER_TO_PARTENAIRES_REQUEST = 'SEND_OFFER_TO_PARTENAIRES_REQUEST';
export const SEND_OFFER_TO_PARTENAIRES_SUCCESS = 'SEND_OFFER_TO_PARTENAIRES_SUCCESS';
export const SEND_OFFER_TO_PARTENAIRES_FAIL = 'SEND_OFFER_TO_PARTENAIRES_FAIL';

export const CLEAR_RECRUTEMENT_EMAIL_STATE = 'CLEAR_RECRUTEMENT_EMAIL_STATE';



export const setDemandesRecrutementLoading = (payload) => ({
    type: SET_DEMANDES_RECRUTEMENT_LOADING,
    payload,
});

export const setDemandesRecrutementError = (payload) => ({
    type: SET_DEMANDES_RECRUTEMENT_ERROR,
    payload,
});

export const fetchDemandesRecrutementRequest = (options = {}) => ({
    type: FETCH_DEMANDES_RECRUTEMENT_REQUEST,
    payload: options,
});
export const fetchDemandesRecrutementSuccess = (payload) => ({
    type: FETCH_DEMANDES_RECRUTEMENT_SUCCESS,
    payload,
});
export const fetchDemandesRecrutementFail = (payload) => ({
    type: FETCH_DEMANDES_RECRUTEMENT_FAIL,
    payload,
});

export const createDemandeRecrutementRequest = (payload, options = {}) => ({
    type: CREATE_DEMANDE_RECRUTEMENT_REQUEST,
    payload,
    meta: options,
});
export const createDemandeRecrutementSuccess = (payload) => ({
    type: CREATE_DEMANDE_RECRUTEMENT_SUCCESS,
    payload,
});
export const createDemandeRecrutementFail = (payload) => ({
    type: CREATE_DEMANDE_RECRUTEMENT_FAIL,
    payload,
});

export const updateDemandeRecrutementRequest = (id, payload, options = {}) => ({
    type: UPDATE_DEMANDE_RECRUTEMENT_REQUEST,
    payload: { id, payload },
    meta: options,
});
export const updateDemandeRecrutementSuccess = (payload) => ({
    type: UPDATE_DEMANDE_RECRUTEMENT_SUCCESS,
    payload,
});
export const updateDemandeRecrutementFail = (payload) => ({
    type: UPDATE_DEMANDE_RECRUTEMENT_FAIL,
    payload,
});

export const deleteDemandeRecrutementRequest = (id) => ({
    type: DELETE_DEMANDE_RECRUTEMENT_REQUEST,
    payload: { id },
});
export const deleteDemandeRecrutementSuccess = (id) => ({
    type: DELETE_DEMANDE_RECRUTEMENT_SUCCESS,
    payload: id,
});
export const deleteDemandeRecrutementFail = (payload) => ({
    type: DELETE_DEMANDE_RECRUTEMENT_FAIL,
    payload,
});

export const approveDemandeRecrutementRequest = (id) => ({
    type: APPROVE_DEMANDE_RECRUTEMENT_REQUEST,
    payload: { id },
});
export const approveDemandeRecrutementSuccess = (payload) => ({
    type: APPROVE_DEMANDE_RECRUTEMENT_SUCCESS,
    payload,
});
export const approveDemandeRecrutementFail = (payload) => ({
    type: APPROVE_DEMANDE_RECRUTEMENT_FAIL,
    payload,
});

export const rejectDemandeRecrutementRequest = (id, motif) => ({
    type: REJECT_DEMANDE_RECRUTEMENT_REQUEST,
    payload: { id, motif },
});
export const rejectDemandeRecrutementSuccess = (payload) => ({
    type: REJECT_DEMANDE_RECRUTEMENT_SUCCESS,
    payload,
});
export const rejectDemandeRecrutementFail = (payload) => ({
    type: REJECT_DEMANDE_RECRUTEMENT_FAIL,
    payload,
});

export const cancelDemandeRecrutementRequest = (id, motif, options = {}) => ({
    type: CANCEL_DEMANDE_RECRUTEMENT_REQUEST,
    payload: { id, motif },
    meta: options,
});
export const cancelDemandeRecrutementSuccess = (payload) => ({
    type: CANCEL_DEMANDE_RECRUTEMENT_SUCCESS,
    payload,
});
export const cancelDemandeRecrutementFail = (payload) => ({
    type: CANCEL_DEMANDE_RECRUTEMENT_FAIL,
    payload,
});

export const saveDemandeRecrutementCiblageRequest = (id, payload) => ({
    type: SAVE_DEMANDE_RECRUTEMENT_CIBLAGE_REQUEST,
    payload: { id, payload },
});
export const saveDemandeRecrutementCiblageSuccess = (payload) => ({
    type: SAVE_DEMANDE_RECRUTEMENT_CIBLAGE_SUCCESS,
    payload,
});
export const saveDemandeRecrutementCiblageFail = (payload) => ({
    type: SAVE_DEMANDE_RECRUTEMENT_CIBLAGE_FAIL,
    payload,
});

export const sendDemandeRecrutementCiblageRequest = (payload) => ({
    type: SEND_DEMANDE_RECRUTEMENT_CIBLAGE_REQUEST,
    payload,
});

export const sendDemandeRecrutementCiblageSuccess = () => ({
    type: SEND_DEMANDE_RECRUTEMENT_CIBLAGE_SUCCESS,
});

export const sendDemandeRecrutementCiblageFail = (payload) => ({
    type: SEND_DEMANDE_RECRUTEMENT_CIBLAGE_FAIL,
    payload,
});



///emails chasseurts de tete /partenaires

export const sendOfferToChasseursRequest = (payload) => ({
    type: SEND_OFFER_TO_CHASSEURS_REQUEST,
    payload,
});

export const sendOfferToChasseursSuccess = () => ({
    type: SEND_OFFER_TO_CHASSEURS_SUCCESS,
});

export const sendOfferToChasseursFail = (error) => ({
    type: SEND_OFFER_TO_CHASSEURS_FAIL,
    error,
});

export const sendOfferToPartenairesRequest = (payload) => ({
    type: SEND_OFFER_TO_PARTENAIRES_REQUEST,
    payload,
});

export const sendOfferToPartenairesSuccess = () => ({
    type: SEND_OFFER_TO_PARTENAIRES_SUCCESS,
});

export const sendOfferToPartenairesFail = (error) => ({
    type: SEND_OFFER_TO_PARTENAIRES_FAIL,
    error,
});

export const clearRecrutementEmailState = () => ({
    type: CLEAR_RECRUTEMENT_EMAIL_STATE,
});
